// src/components/AboutDialog.js

import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Box } from '@mui/material';

const AboutDialog = ({ open, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>About Zinlanka</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Zinlanka is a modern, real-time chat application built to connect people seamlessly and securely.
        </Typography>
        <Box sx={{ mt: 2 }}>
            <Typography variant="body2" color="text.secondary">
                <strong>Version:</strong> 1.0.0
            </Typography>
            <Typography variant="body2" color="text.secondary">
                <strong>Powered by:</strong> React, Firebase, and Material-UI
            </Typography>
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', p: 2 }}>
        <Typography variant="caption" color="text.secondary">
          © {new Date().getFullYear()} Kushan & Co.Technologies LLC
        </Typography>
      </DialogActions>
    </Dialog>
  );
};

export default AboutDialog;